<page-grid [gridConfig]="paymentsMadeGrid" (gridClickColumn)="openDialog($event)" (gridEvent)="openCreatePaymentDialog();" />